"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusColor = void 0;
exports.statusColor = {
    corrected: "#E5F2FF", //校閲済み
    null: "#FFF8E5", // 未着手
    translationEmpty: "#FFEFEB", // 翻訳が空
    translated: "#E5FFDF", // 翻訳済み
    selectedText: "#E8E8F0", // 選択中テキスト
    updated: "#ffffff",
    skipped: "#FFE5E5", // 保留
};
